import React from 'react';

const TitleDescription = ({content}) => {

    return (
        <section className={'t_d'}>
            <div className="container">
                <div className="t_d_wrapper">
                    <h2 className={'t_d_title'}><span>{content.title}</span></h2>
                    <p className={'t_d_text'}>{content.text}</p>
                </div>
            </div>
        </section>
    );
};

export default TitleDescription;